module.exports = __webpack_public_path__ + "static/media/private-pool.b2826428.svg";